import styled from '@emotion/styled';
import { LayoutDirection } from '@/types';

export const AppWrapper = styled.div`
  height: calc(100vh - 60px); /* Subtract header height */
  display: flex;
  flex-direction: column;
`;

interface WorkspaceWrapperProps {
  direction: LayoutDirection;
}

export const WorkspaceWrapper = styled.div<WorkspaceWrapperProps>(
  ({ direction }) => ({
    height: '100%',
    display: 'flex',
    width: '100%',
    flexDirection: direction,
  })
);

interface WorkspaceProps {
  width?: number;
  basis?: string;
  grow?: number;
  shrink?: number;
}

export const Workspace = styled.div<WorkspaceProps>(
  ({ theme, width, basis, grow, shrink }) => ({
    position: 'relative',
    display: 'flex',
    flexGrow: grow ?? 1,
    flexShrink: shrink ?? 1,
    flexBasis: basis ?? 'auto',
    flexDirection: 'column',
    width: width ?? '100%',
    overflow: 'hidden',
    borderLeft: `1px solid ${theme.colors.gray[2]}`,
    boxShadow: `0 0 1em ${theme.colors.gray[1]}`,
    backgroundColor: 'white',
  })
);

export const ResizeHandle = styled.div<WorkspaceWrapperProps>(
  ({ theme, direction }) => ({
    flexShrink: 0,
    backgroundColor: theme.colors.gray[2],
    width: direction === LayoutDirection.Row ? 2 : '100%',
    height: direction === LayoutDirection.Row ? '100%' : 2,
    cursor: direction === LayoutDirection.Row ? 'col-resize' : 'row-resize',
    position: 'relative',
    zIndex: 1,
    '&:hover': {
      backgroundColor: theme.colors.gray[3],
    },
    '&:hover .resize-grip': {
      transform: 'translate(-50%, -50%) scale(1.1)',
      boxShadow: `0 0 0 2px ${theme.colors.gray[3]}`,
    },
  })
);

export const ResizeGrip = styled.div<WorkspaceWrapperProps>(
  ({ theme, direction }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: direction === LayoutDirection.Row ? 18 : 34,
    height: direction === LayoutDirection.Row ? 34 : 18,
    borderRadius: 6,
    backgroundColor: theme.white,
    border: `1px solid ${theme.colors.gray[3]}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.colors.gray[6],
    transformOrigin: 'center',
    transition: 'transform 150ms ease, box-shadow 150ms ease',
  })
);

export const ResizeGripIndicator = styled.div<WorkspaceWrapperProps>(
  ({ theme, direction }) => ({
    width: direction === LayoutDirection.Row ? 2 : 20,
    height: direction === LayoutDirection.Row ? 20 : 2,
    borderRadius: 4,
    backgroundColor: theme.colors.gray[4],
  })
);
